import React, { useEffect, useState } from "react";
import { PropTypes } from "prop-types";
import { Layout, Container, StyledLabel, StyledInputV2, InputContainer, UploadPhotoContainerV1, RemoveImageV3, InputImageV1, EditorContainer, ButtonContainer, CustomCheckBoxButton, Border } from "../../components/CreateEvent/style";
import StepsHeading from "../../components/RecogntionAdmin/corevalues/stepNames";
import { AdminLeftArrowIcon, AdminRightArrowIcon, RecognitionCloseIcon, RecognitionTickIcon, UploadHDMIcon, closeIcon } from "../../utils/icons";
import { fetchApi,checkImage, getOrientation, resetOrientation } from "../../utils/methods";
import { toast } from "react-toastify";
import { imageErrorMessage } from "../../utils/constants";
import Editor from "../CKEditor";
import { Main } from "../AdminTeamCreation/styles";
import { connect } from "react-redux";
import { getOndemandCategory } from "../../redux/actions";
import { CreateCoach } from "../../redux/constants/apiConstants";
import { FormHeading } from "../ChallengeCreationAdmin/ActivityChallengeLaunch/style";
import { ManagerIconContainer } from "../Manager/styles";
import { CommonButtonPopup } from "../ReportsV2/styles";
import { CommonButtonBorder } from "../common/commonStyles";

function EventCoachCreate(props) {
  const {history} = props;
  const [step, setStep] = useState(1);
  const [name, setName] = useState('');
  const [imgSrc, setImgSrc] = useState('');
  const [imageName, setImageName] = useState('');
  const [about, setAbout] = useState('');
  const [charCount, setCharCount] = useState(0);
  const[classCategoryTypeValue, setClassCategoryTypeValue] = useState([]);
  const [selectedClass, setSelectedClass] = useState({
    name: '',
    classTypeKey: null,
  });
  const [educationSpecialization, setEducationSpecialization] = useState('');
  const[buttonStatus,setButtonStatus] = useState(false);


  useEffect(() => {
    props.fetchOndemandCategory();
    window.console.log("imageName", imageName)
  
  },[])


  const redirect = () => {
    history.push(`/company/events`);
  };



  const renderHeading = (title) => {
    window.console.log("hi")
    return(
      <FormHeading color={"#184A61"}>
        <div className="close-icon" onClick={redirect }>
          <ManagerIconContainer isWidth={"32px"}>{RecognitionCloseIcon('#F37A65')}</ManagerIconContainer>
        </div>
        {title}
      </FormHeading>
    )};

  const onChangeProfileImage = (e) => {
    let file = e.target.files[0];
    let fileArr = e.target.files;
    if (e.target.files[0]) {
      if (checkImage(fileArr)) {
        if (file?.size / 1000000 <= 20) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          
          const array = document
            .getElementById("event-upload-file")
            .value.split("\\");
          reader.onloadend = () => {
            setImgSrc(reader.result);
            setImageName(array[array.length - 1]);
            
            getOrientation(file, (or) => {
              resetOrientation([reader.result], or, (baseImage) => {
                setImgSrc(baseImage)
                setImageName(array[array.length - 1])
              });
            });
          };
        } else {
          toast.error("Please select image file less than 20MB");
          document.getElementById("event-upload-file").value = "";
        }
      } else {
        toast.error(imageErrorMessage);
        document.getElementById("event-upload-file").value = "";
      }
    }
  };

  const removePhoto = () => {
    setImgSrc('');
    setImageName('');
  }

  const updateStep = (stepValue) => {
    setStep(stepValue);
  }

  const onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    const plainText = newContent.replace(/<[^>]*>/g, "").trim(); // Strip HTML tags for char count
    const currentLength = plainText.length;
    setCharCount(currentLength);
    trimmedString.length === 0 || trimmedString.length === 7 || trimmedString == "<p></p><p></p>" ? setAbout('') : setAbout(newContent) ; 
  }

  const onSelectClass = (name, value, key) => {

    let updatedClassCategoryTypeValue = [...classCategoryTypeValue];

    if (updatedClassCategoryTypeValue.includes(value)) {
      updatedClassCategoryTypeValue = updatedClassCategoryTypeValue.filter((item) => item !== value);
    } else {
      if (updatedClassCategoryTypeValue.length <= 4) {
        updatedClassCategoryTypeValue.push(value);
      }
    }

    setClassCategoryTypeValue(updatedClassCategoryTypeValue);
    setSelectedClass({
      name: value.toString(),
      classTypeKey: key,
    });

    window.console.log("selectedClass",selectedClass)
  };

  const PostEvent = async()=>{

    const payload = {
      name:name,
      about_me:about,
      intrested_area_id:classCategoryTypeValue,
      education:educationSpecialization,
      profile_image:imgSrc
    };
    setButtonStatus(true);
    
    try{

      const res = await fetchApi(CreateCoach, "POST",payload);

      if(res.message){
        toast.error(res.message);
        setButtonStatus(false);
      }else{
        toast.success(res.data[0]);
        history.push({pathname:"/company/events"});
        setButtonStatus(false);
      }

    }catch(error){
      toast.error(error)

    }
  }

  const stepOne = () => (
    <Layout>
      <div className="main" >
        {renderHeading("Add New Coach")}

        <Container height="100%" stepBackground="#005C87" color="#005C87" paddingForm>
          <div className="stepsNameHighlight">
            <StepsHeading stepCount={step} type="create-coach" padding="20px 20px 265px 20px" />
          </div>
          <div className="form">
            {/* <div className="heading">
              <div className="step">
                {step}
              </div>
              <div className="headingName" style={{color: "#005c87"}}>
                {"Coach Introduction"}
              </div>
            </div> */}
            <div className="formBody">
              <InputContainer>
                <StyledLabel  isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"}>{"Coach Name"}{<span>*</span>}</StyledLabel>
                <StyledInputV2
                  placeholder={"Enter name"}
                  name="title"
                  onChange={(e)=>{setName(e.target.value)}}
                  value={name}
                  maxLength="30"
                  style={{background:"white"}}
                  pColor={"#BDBDBD"}
                  color="#184A61"
                  border={"1px solid #BDBDBD"}
                />
                <div className="count">{name?.length}/30 | C</div>
              </InputContainer>
              <Border style={{ background: '#EFEFEF', margin: '20px 0 8px 0px' }} />
              <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" marginb="12px" symbolSize={"14px"}>{"Profile Image"}{<span>*</span>}</StyledLabel>
              <UploadPhotoContainerV1>
                <div className="innerDivImageContainer">
                  {imgSrc ? (
                    <RemoveImageV3>
                      <img alt="profilre-img" src={imgSrc}></img>
                      <div className="main-div" onClick={removePhoto}>
                        <div className="icon-div" ><div className="sub-icon-div">{closeIcon("#F37A65","8","8")}</div></div>
                      </div>
                    </RemoveImageV3>
                  ) : (
                    <div className="uploadImage">

                      <InputImageV1
                        className="edit-profile-pic "
                        imageReload={1} 
                        style={{background:"unset",color:"#005c87"}}
                      >
                        <div className="middle-section">
                          <div className="iconContainer">{UploadHDMIcon(20,25)}</div>
                          <div className="title">{"Upload File"}</div>
                          <div className="sub-title">{"(.jpeg, .png)"}</div>
                          
                        </div>
                        <input
                          id="event-upload-file"
                          type="file"
                          name="user"
                          accept=".jpeg, .png, .jpg"
                          multiple={false}
                          onChange={(e) => onChangeProfileImage(e)}
                          onClick={(e) =>
                            e.target.files[0] && onChangeProfileImage(e)
                          }
                        />
                      </InputImageV1>
                    </div>
                  )}
                </div>
              </UploadPhotoContainerV1>
              <Border style={{ background: '#EFEFEF', margin: '8px 0px'}}/>        
              <InputContainer isColorError={charCount > 3000 ? true : false}>
                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" symbolSize={"14px"} > {"About the Coach"} <span>*</span></StyledLabel>
                <EditorContainer>
                  <Editor
                    content={about}
                    onChange={onChangeDescription}
                    placeholder={"Write description here..."}
                  />
                </EditorContainer>
                <div className="char-count">{charCount}/3000 | C</div>
              </InputContainer>
            </div>
          </div>
        </Container>
      </div>
    </Layout>
  )

  const stepTwo = () => (
    
    <Layout>
      <div className="main" >
        {renderHeading("Add New Coach")}

        <Container color="#005C87">
          <div className="stepsNameHighlight">
            <StepsHeading stepCount={step} type="create-coach" />
          </div>
          <div className="form">
            {/* <div className="heading">
              <div className="step">
                {step}
              </div>
              <div className="headingName" style={{color: "#005c87"}}>
                {"Area of wellness expertise"}
              </div>
            </div> */}

            <div className="formBody">
              <InputContainer>
                <StyledLabel isFont={"14px"} color={"#184A61"} margin="0px" >{"Select category"} {<div className="subDescription">(min 1 & max 5) </div>}{<span>*</span>}</StyledLabel>

                <div className="radioButtonClassCategoriesV1" >
                  {
                    props.ondemandCategory.map((category, index)=>(
                      <div className="labelName" key={category.id}>
                        <CustomCheckBoxButton
                          onClick={() => {
                            onSelectClass(
                              "classCategoryTypeValue",
                              props.ondemandCategory[index].id,
                              props.ondemandCategory[index].name
                            );
                            // this.setState({
                            //   selectedOndemandCategory: props.ondemandCategory[index].name
                            // });
                          }}
                          isSelected={classCategoryTypeValue?.includes(category.id)}
                          background={"#85c0ea"}
                        >
                          { classCategoryTypeValue?.includes(props.ondemandCategory[index].id) && <div>{RecognitionTickIcon()}</div>}
                        </CustomCheckBoxButton>
                        {category.name}
                      </div>
                    ))
                  }
                </div>

              </InputContainer>
              <Border style={{ background: '#EFEFEF', margin: '8px 0px'}}/>        
              <InputContainer>
                <StyledLabel isFont={"14px"} color={"#184A61"} marginb="12px" margin="0px">{"Education/Specialization"}{<span>*</span>}</StyledLabel>
                <StyledInputV2
                  pColor={"#BDBDBD"}
                  color="#184A61"
                  placeholder={"Enter education"}
                  name="title"
                  onChange={(e)=>{setEducationSpecialization(e.target.value)}}
                  value={educationSpecialization}
                  maxLength="100"
                  style={{background:"white"}}
                  border={"1px solid #BDBDBD"}
                />
              </InputContainer>

              
              
            </div>
          </div>
        </Container>
      </div>
    </Layout>
  )
  
  return (
    <React.Fragment>
      { step === 1 
        ? stepOne()
        : step === 2 && stepTwo()
      }
      { step === 1 ? (
        <ButtonContainer>
          <Main>
            <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto" disabled={!name||!imgSrc|| !about || (charCount > 3000)} onClick={!name||!imgSrc|| !about || (charCount > 3000)?null: () => updateStep(2)}>
                Next
              {!name||!imgSrc|| !about || (charCount > 3000) ? AdminRightArrowIcon("#989898") : AdminRightArrowIcon()}
            </CommonButtonPopup>
          </Main>
        </ButtonContainer>
      ) : step === 2 && (
        <ButtonContainer>
          <div className="wrapper">
            <CommonButtonBorder width="200px" height="48px"
              onClick={() => updateStep(1)}
              margin="auto auto auto 0px">
              {AdminLeftArrowIcon("#F37A65")}
               Back
            </CommonButtonBorder>
            {/* <CommonButton
              btnType={"squareIcon"}
              disabled={!(classCategoryTypeValue.length>4&&classCategoryTypeValue.length<=8) || !educationSpecialization || buttonStatus}
              // disabled={buttonStatus}
              styles={{marginAuto:"auto",color:"#007AB1" }}
              onClick={() => PostEvent()}
              title={"Submit"}
              nextIcon={LaunchEventIcon()}
            /> */}
            <CommonButtonPopup height="48px" width="200px" margin="auto 0 auto auto"   disabled={!(classCategoryTypeValue.length>1&&classCategoryTypeValue.length<=5) || !educationSpecialization || buttonStatus}   onClick={!(classCategoryTypeValue.length>1&&classCategoryTypeValue.length<=5) || !educationSpecialization || buttonStatus ? null: () => PostEvent()}>
               Create Coach
            </CommonButtonPopup>
          </div>
        </ButtonContainer>
      )
      }
    </React.Fragment>
  )
}

EventCoachCreate.propTypes = {
  history: PropTypes.object,
  parentRoute: PropTypes.string,
  allowedRoles: PropTypes.bool,
  userPermissions: PropTypes.array,
  fetchOndemandCategory: PropTypes.func,
  ondemandCategory: PropTypes.array,
}

const mapStateToProps = (state) => ({
  ondemandCategory: state.events.ondemandCategory,

})

const mapDispatchToProps = (dispatch) => ({
  fetchOndemandCategory: () => dispatch(getOndemandCategory()),

})

export default connect(mapStateToProps, mapDispatchToProps)(EventCoachCreate);
